import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import { Gallery } from './Gallery';
import styles from './GalleryLayout.css';
import { IFotoramaData } from '../../../../typings/fotorama';
import { GalleryPlaceholderContainer } from '../../../containers/GalleryPlaceholder';
import { MobileFullScreenGalleryContainer } from '../../../containers/MobileFullScreenGallery';
import { trackGalleryFullScreenEnter } from '../../../tracking';
import { PopupMobile } from '../popup_mobile';

export interface IGalleryLayoutStateProps {
  slides: IFotoramaData[];
  isFat?: boolean;
}

type TGalleryLayoutProps = IGalleryLayoutStateProps;

interface IGalleryLayoutState {
  currentSlide: number;
  galleryStartSlideIndex: number;
  isGalleryInited: boolean;
}

export class GalleryLayout extends React.Component<TGalleryLayoutProps, IGalleryLayoutState> {
  public state = {
    currentSlide: 0,
    galleryStartSlideIndex: 0,
    isGalleryInited: false,
  };

  public render() {
    const { slides, isFat } = this.props;

    const { currentSlide, galleryStartSlideIndex, isGalleryInited } = this.state;

    return (
      <div {...mergeStyles(styles['container'], isFat && styles['fat_container'])}>
        <PopupMobile
          animation="opacity"
          onOpen={trackGalleryFullScreenEnter}
          popupContent={({ onClose }) => (
            <MobileFullScreenGalleryContainer
              startWithSlide={currentSlide}
              slideDidChange={this.changeCurrentSlide}
              onClose={() => {
                onClose();
                this.setState({ galleryStartSlideIndex: currentSlide });
              }}
            />
          )}
        >
          {!isGalleryInited && <GalleryPlaceholderContainer />}
          <div {...mergeStyles(styles['gallery_container'], !isGalleryInited && styles['gallery_container--hidden'])}>
            <Gallery
              slides={slides}
              onSlideChange={this.changeCurrentSlide}
              onInit={this.onGalleryInit}
              startWithIndex={galleryStartSlideIndex}
              isFat={isFat}
            />
          </div>
        </PopupMobile>
      </div>
    );
  }

  private changeCurrentSlide = (currentSlide: number) => {
    this.setState({ currentSlide });
  };

  private onGalleryInit = () => {
    setTimeout(() => {
      this.setState({ isGalleryInited: true });
    }, 300);
  };
}
